$('.js-carousel').slick({
	dots: false,
	slidesToShow: 3,
	arrows: false,
	infinite: true,
	centerMode: true,
	variableWidth: true,
	autoplay: true,
  autoplaySpeed: 0,
  speed: 10000,
  cssEase: 'linear'
});
